export function upperSnakeCaseToCamelCase(input: string) {
  const words = input.split('_');
  const camelCased = words.map((word, index) => {
    if (index === 0) return word.toLowerCase(); // Convert the first word to lowercase
    return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
  });
  return camelCased.join('');
}
